import { Inject, Injectable } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';

@Injectable({
  providedIn: 'root',
})
export class DeviceDetailService {
  constructor(
    @Inject('tablePaddingHeight') private tablePaddingHeight: number,
    @Inject('itemHeight') private itemHeight: number,
    @Inject('paginations') public readonly paginations: number[]
  ) {}

  public calculatePagination(paginator: MatPaginator) {
    const tabHeight = document.getElementById('device-tab-group')?.offsetHeight;
    if (tabHeight) {
      const tableHeight = tabHeight - this.tablePaddingHeight;
      this.calculatePaginationByHeight(paginator, tableHeight);
    }
  }

  public calculatePaginationByHeight(paginator: MatPaginator, height: number) {
    const pageSize = Math.floor(height / this.itemHeight);
    if (paginator) {
      paginator.pageSizeOptions = [
        ...new Set([...this.paginations, pageSize]),
      ].sort((a, b) => a - b);
      paginator.pageSize = pageSize;
      paginator.pageIndex = 0;
    }
  }
}
